import {
  type CompletePath,
  type ID,
  ProjectActions,
} from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { artBoardActions } from '@store/reducers/artboard'
import { selectThread, type Thread } from '@store/reducers/threads'
import { CanvasActionTypes } from '@storeOld/reducers/canvas/canvas'
import { delay, put, select } from 'redux-saga/effects'

import { GlobalActions } from '@/store'

export function* jumpToThread({
  payload: { id },
}: ReturnType<typeof artBoardActions.jumpToThread>) {
  const thread: Thread | null = yield select(selectThread(id))

  const path: CompletePath = yield select(
    migrationProjectSelector.getCompletePath(thread?.commentable as ID)
  )

  if (!path || !thread) {
    return
  }

  const [tab, section, nodes] = path

  const { uuid } = thread

  yield put({
    type: CanvasActionTypes.SET_ACTIVE_TAB,
    payload: tab,
  })

  yield put({
    type: CanvasActionTypes.SET_SELECTED_THREAD,
    payload: uuid,
  })

  if (section) {
    yield put(
      ProjectActions.sections.changeCollapse({
        ids: [section],
        collapsed: false,
      })
    )
  }

  yield put(
    ProjectActions.nodes.changeCollapse({
      ids: nodes,
      collapsed: false,
    })
  )

  yield delay(1) // todo: fix jump does not work on tab change
  yield put(
    GlobalActions.jumpTo({
      selector: 'data-jump-id',
      value: uuid,
    })
  )
}
